var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 139,
    viewBox: "0 0 178 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_270",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 178,
    height: 139
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.903 0.435486H0.0967712V138.565H177.903V0.435486Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.581 34.1797C99.524 41.578 104.829 52.5853 114.754 43.7434",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6595 29.738H127.277",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.437 28.8981L102.029 25.4681C102.805 20.9733 105.583 17.8219 108.77 17.8219H114.077C117.137 17.8219 119.837 20.7327 120.727 24.9909L121.719 29.738",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.218 46.1912C111.218 46.1912 111.289 49.8786 112.805 53.4875",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6 29.738C120.6 29.738 119.861 42.5122 123.607 47.0926",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.702 47.6522C127.702 47.6522 120.168 44.2291 112.805 54.0815L107.031 60.8317H92.6309C89.1927 60.8317 86.4055 63.6189 86.4055 67.0571C86.4055 70.4954 89.1927 73.2826 92.6309 73.2826H107.363C112.895 73.2826 118.016 70.3627 120.833 65.6021L123.848 60.5069",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.612 39.5069L132.203 41.8793C129.11 42.6593 127.234 45.7993 128.014 48.8928L133.763 71.6912C134.543 74.7847 137.683 76.6602 140.776 75.8802L150.185 73.5078C153.279 72.7278 155.154 69.5877 154.374 66.4942L148.626 43.6959C147.846 40.6024 144.706 38.7269 141.612 39.5069Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.012 72.5759L113.238 78.6779C113.238 78.6779 108.314 82.8226 109.397 97.2584",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.238 78.6779L134.164 73.2826",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.641 76.1665C139.641 76.1665 139.975 83.4566 133.859 91.6201L140.28 122.389",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.208 81.9982C117.208 81.9982 120.095 82.323 120.6 91.3092C121.105 100.295 122.104 105.384 122.104 105.384L125.184 123.505H112.805L109.241 107.113",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.542 70.1294C140.154 70.1294 142.272 68.0119 142.272 65.3999C142.272 62.7879 140.154 60.6705 137.542 60.6705C134.93 60.6705 132.813 62.7879 132.813 65.3999C132.813 68.0119 134.93 70.1294 137.542 70.1294Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.066 64.0582L153.065 61.6604",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.252 34.1253C137.988 33.4353 140.77 35.0968 141.46 37.8334L141.83 39.3002L131.914 41.8006L131.544 40.3338C130.854 37.5972 132.515 34.8153 135.252 34.1253Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.18 70.1294C135.18 70.1294 133.665 87.0655 117.208 90.3061C100.751 93.5468 94.1827 79.7245 92.6309 73.2826",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7463 61.5403L87.1082 56.947C86.3081 55.5539 84.5869 54.9875 83.1159 55.6333L79.7831 57.0965",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0934 50.4921L76.2824 54.2274",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8257 65.2707L74.2795 59.9115",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.866 79.8328L78.1771 63.5384",
    stroke: "#E8BA3A",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.663 123.505H12.3368C9.3065 123.505 6.84999 125.962 6.84999 128.992V129.252C6.84999 132.282 9.3065 134.739 12.3368 134.739H165.663C168.693 134.739 171.15 132.282 171.15 129.252V128.992C171.15 125.962 168.693 123.505 165.663 123.505Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8611 106.268C30.5442 104.385 34.8387 94.1381 46.2169 97.9931C46.3736 98.0462 46.4639 98.2144 46.4184 98.3734C45.8699 100.287 42.1901 111.089 30.0498 106.667C29.8885 106.608 29.8025 106.43 29.8611 106.268Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8243 106.268C29.1412 104.385 24.8467 94.1381 13.4684 97.9931C13.3118 98.0462 13.2214 98.2144 13.267 98.3734C13.8154 100.287 17.4953 111.089 29.6355 106.667C29.7969 106.608 29.8828 106.43 29.8243 106.268Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8243 106.268V122.389",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1265 106.268C65.8096 104.385 70.1041 94.1381 81.4824 97.9931C81.639 98.0462 81.7294 98.2144 81.6838 98.3734C81.1354 100.287 77.4555 111.089 65.3153 106.667C65.1539 106.608 65.068 106.43 65.1265 106.268Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0897 106.268C64.4067 104.385 60.1121 94.1381 48.7339 97.9931C48.5772 98.0462 48.4869 98.2144 48.5325 98.3734C49.0809 100.287 52.7607 111.089 64.901 106.667C65.0623 106.608 65.1483 106.43 65.0897 106.268Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0897 106.268V123.79",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5592 106.268C100.242 104.385 104.537 94.1381 115.915 97.9931C116.072 98.0462 116.162 98.2144 116.116 98.3734C115.568 100.287 111.888 111.089 99.748 106.667C99.5866 106.608 99.5007 106.43 99.5592 106.268Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5224 106.268C98.8393 104.385 94.5448 94.1381 83.1666 97.9931C83.0099 98.0462 82.9196 98.2144 82.9651 98.3734C83.5136 100.287 87.1934 111.089 99.3337 106.667C99.495 106.608 99.581 106.43 99.5224 106.268Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5224 106.268V123.505",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1859 31.8226V67.4824H51.0196L36.7619 85.6938L22.5041 67.4824H30.3377V31.8215L43.1859 31.8226Z",
    stroke: "#193C34",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.9859db2882ad0af7311ccc62b5e0f71d.svg";
export { ForwardRef as ReactComponent };